var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstantWinInactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b7312c;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.8,47.2c-1.1,0-1.9-.9-1.9-1.9V14.8c0-1.1.9-1.9,1.9-1.9h30.5c1.1,0,1.9.9,1.9,1.9v13h3v-13c0-2.7-2.2-4.9-4.9-4.9H14.8c-2.7,0-4.9,2.2-4.9,4.9v30.5c0,2.7,2.2,4.9,4.9,4.9h13v-3h-13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.2,29.8h-30.5c-2.7,0-4.9,2.2-4.9,4.9v30.5c0,2.7,2.2,4.9,4.9,4.9h30.5c2.7,0,4.9-2.2,4.9-4.9v-30.5c0-2.7-2.2-4.9-4.9-4.9M32.8,34.7c0-1.1.9-1.9,1.9-1.9h30.5c1.1,0,1.9.9,1.9,1.9v30.5c0,1.1-.9,1.9-1.9,1.9h-30.5c-1.1,0-1.9-.9-1.9-1.9v-30.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.5,18.6c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9,2.9-1.3,2.9-2.9h0c0-1.6-1.3-2.9-2.9-2.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.5,35.7c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9,2.9-1.3,2.9-2.9h0c0-1.6-1.3-2.9-2.9-2.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.7,21.5c0,1.6,1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9-1.3-2.9-2.9-2.9h0c-1.6,0-2.9,1.3-2.9,2.9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.4,44.3c1.6,0,2.9-1.3,2.9-2.9s-1.3-2.9-2.9-2.9-2.9,1.3-2.9,2.9h0c0,1.6,1.3,2.9,2.9,2.9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.4,61.4c1.6,0,2.9-1.3,2.9-2.9s-1.3-2.9-2.9-2.9-2.9,1.3-2.9,2.9h0c0,1.6,1.3,2.9,2.9,2.9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,52.8c1.6,0,2.9-1.3,2.9-2.9s-1.3-2.9-2.9-2.9-2.9,1.3-2.9,2.9h0c0,1.6,1.3,2.9,2.9,2.9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.5,44.3c1.6,0,2.9-1.3,2.9-2.9s-1.3-2.9-2.9-2.9-2.9,1.3-2.9,2.9h0c0,1.6,1.3,2.9,2.9,2.9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.5,61.4c1.6,0,2.9-1.3,2.9-2.9s-1.3-2.9-2.9-2.9-2.9,1.3-2.9,2.9h0c0,1.6,1.3,2.9,2.9,2.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantWinInactive);
export default __webpack_public_path__ + "static/media/InstantWin-inactive.da57ecce366acc0ae97cd935ef4f2b09.svg";
export { ForwardRef as ReactComponent };